/**
 * Created by asiulik on 19.05.2017.
 */

define(['jquery', 'lodash', '../pageConst', '../../../utils'], function ($, _, PageConst, Utils) {

    var $body = $('body');
    var $content = $('#content');

    var _transformKey = 'transform', _translatePrefix = "translate3d(", _translateSufix = ", 0px)";

    var animationHelper = {
        applyZoomTransform: function (obj, x, y, zoom) {
            var val = _translatePrefix + x + 'px, ' + y + 'px' + _translateSufix + ' scale(' + zoom + ')';
            obj.css(_transformKey, val);
        }
    };

    var templates = {
        pageHeadlineTemplate: '<div class="container">\n    <header class="text text--align-center page__header">\n        <h1><%= header %></h1>\n        <p class="paragraph paragraph--lead">\n            <%= desc %>\n        </p>\n    </header>\n</div>',
        subHeaderTemplate: '<div id="subheader" class="subheader" >\n    <div id="subheader__category" class="subheader__category"> <span style="opacity: 0;"\n                                                                     class="subheader__category__name">bauwerk</span>\n        <span style="opacity: 0;" class="subheader__category__icon">            <svg\n                xmlns="http://www.w3.org/2000/svg" width="11" height="7" viewBox="0 0 11 7">              <polyline\n                fill="none" stroke="#FFF" points="154 13 159.053 18 164 13" transform="translate(-154 -12)"/>            </svg>        </span>\n    </div>\n    <ul class="subheader__links">\n        <li class="subheader__link subheader__link--active"><a style="opacity: 0" href="#">bauwerk</a></li>\n        <li class="subheader__link"><a style="opacity: 0" href="#">bauwerk</a></li>\n        <li class="subheader__link"><a style="opacity: 0" href="#">bauwerk</a></li>\n    </ul>\n</div>'
    };

    function buildTemplateForChangePageAnimation($link) {

        var templateContainer = '<div id="changePageContainer" class="change__container change__container--hidden">\n    <div class="page">';

        if($link.data('subheader')){

            templateContainer += templates.subHeaderTemplate;
        }

        if($link.data('headline')){

            // console.log('powinien byc headline')

            templateContainer += _.template(templates.pageHeadlineTemplate)({
                header: $link.data('headline'),
                desc: $link.data('lead')
            });
        }

        templateContainer += '<div style="position: relative" class="container">\n    <div style="overflow: visible" class="m__header">\n        <div class="change__container__image">\n        </div>\n    </div>\n</div>\n<div class="preloader preloader--hidden preloader--relative">\n    <div class="progress"></div>\n</div>'

        templateContainer += '</div></div>';

        return templateContainer;

    }

    function changePageExpandSuccess(data, url, animationConfig, $link) {

        var _this = this;

        var $data = $(data);
        var $dataContent = $data.find('#content');

        this.customAnimationData.backAction = 'changePageThemenFinderBack';
        this.customAnimationData.$content = $content.clone();

        if (!$dataContent || !$dataContent.length)
            throw new Error('response page contain incorrect structure: ' + '#content' + ' selector not found.')

        var changePageContainer = buildTemplateForChangePageAnimation($link),
            $changePageContainer = $(changePageContainer),
            $heroImage = $dataContent.find('.m__header .header__image');

        $body.append($changePageContainer);

        var $imageToExpand = $link.find('.teaser');

        Utils.setBgImage(
            $heroImage.get(0),
            Utils.getBgImage($imageToExpand.get(0))
        );

        var $cloneImageToExpand = $imageToExpand.clone();
        $cloneImageToExpand.addClass('anim-item-change-page');

        $cloneImageToExpand.find('.teaser__content').remove();

        var expandImagePosition = Utils.getViewportOffset($imageToExpand);

        var imageX = $imageToExpand.offset().left;
        var imageY = expandImagePosition.top;

        $changePageContainer.find('.change__container__image').append($cloneImageToExpand);

        $cloneImageToExpand.css({
            width: "100%",
            height: "100%"
        });

        var scale = $imageToExpand.width() / $cloneImageToExpand.width();

        _.delay(function () {

            $changePageContainer.removeClass('change__container--hidden');
            animationHelper.applyZoomTransform($cloneImageToExpand, imageX, imageY, scale);

            // _this.preloader.hide();

            _.delay(function () {

                $cloneImageToExpand.addClass('change-page-item');
                animationHelper.applyZoomTransform($cloneImageToExpand, 0, 0, 1);

                _.delay(function () {

                    $changePageContainer.find('.preloader--hidden').removeClass('preloader--hidden');

                }, 300);

                _.delay(function () {

                    $content.html($dataContent.html());

                    _this.emit('getPageDone', {data: $data});

                    _.delay(function () {

                        $changePageContainer.addClass('change__container--hidden');
                        $changePageContainer.remove();

                    }, 50)
                }, 1000)
            }, 100)
        }, 200);

    }

    return function (url, animationConfig, $link) {

        var _this = this;

        // this.preloader.show();

        this.ajaxPage(url)
            .done(function (data) {

                if (data === 'redirect') {
                    return;
                }

                return changePageExpandSuccess.call(_this, data, url, animationConfig, $link);

            }).fail(function (data) {

            try {

                return changePageExpandSuccess.call(_this, data.responseText, url, animationConfig, $link);

            } catch (e) {

                // console.log('teaser expand change page error', e);

                _this.emit('getPageFail');
                // _this.preloader.hide();

            }

        });
    }

});



// WEBPACK FOOTER //
// ./Private/Scripts/core/page/changePageAnimations/changePageTeaserExpand.js